// Third-party
import React from 'react';
import { connect } from 'react-redux';

// Components
import { ToggleSwitch } from '../inputs';
import { Tooltip } from '../tooltips';

// Utils
import { FormattedMessage, formatMessage } from '../../../utils/i18n';

// Actions
import { ReduxState } from '../../../redux/modules/types';
import { setCalculationBenchmark, calculateCustomBenchmarks } from '../../../redux/modules/comparison';
import Nullable from '@/types/nullable';
import ComparisonItem from '@/types/comparison-item';

type StateProps = {
  selectedBenchmarkId: Nullable<string>;
};

type DispatchProps = {
  setCalculationBenchmark: (benchmarkId: Nullable<string>) => void;
  calculateCustomBenchmarks: (benchmark: ComparisonItem) => void;
};

type Props = DispatchProps &
  StateProps & {
    item: ComparisonItem;
    disabled?: boolean;
  };

class BenchmarkToggler extends React.PureComponent<Props> {
  onChange = (checked: boolean) => {
    const { selectedBenchmarkId } = this.props;
    if (!checked && selectedBenchmarkId) {
      this.props.setCalculationBenchmark(null);
    } else {
      this.props.setCalculationBenchmark(this.props.item._id);
      this.props.calculateCustomBenchmarks(this.props.item);
    }
  };

  render() {
    const { item, selectedBenchmarkId, disabled } = this.props;
    const checked = !!selectedBenchmarkId && selectedBenchmarkId === item._id;
    return (
      <Tooltip disabled={!disabled} message={formatMessage('Comparison.ReadOnlyUseThisBenchmarkTooltip')} place="bottom">
        <div>
          <ToggleSwitch checked={checked} className="cell toggle-benchmark-cell" onChange={this.onChange} disabled={disabled}>
            <FormattedMessage id="Comparison.UseBenchmark" />
          </ToggleSwitch>
        </div>
      </Tooltip>
    );
  }
}

const mapStateToProps = (state: ReduxState) => {
  const currentComparison = state.comparison.activeComparison;

  if (!currentComparison) {
    throw new Error('Unable to find current comparison');
  }

  return {
    selectedBenchmarkId: currentComparison.selectedBenchmarkId,
  };
};

export default connect(mapStateToProps, {
  calculateCustomBenchmarks,
  setCalculationBenchmark,
})(BenchmarkToggler);
